import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import { registerServiceWorker } from './serviceWorkerRegistration';

const SplashScreen = () => (
  <div id="app-splash" role="status" aria-label="Loading Ootfit Admin">
    <img src="/assets/partner-splash.png" alt="Ootfit Partner" />
  </div>
);

const AppBootstrap = () => {
  const [showSplash, setShowSplash] = React.useState(true);

  React.useEffect(() => {
    const splashTimer = window.setTimeout(() => setShowSplash(false), 1400);
    return () => window.clearTimeout(splashTimer);
  }, []);

  return showSplash ? <SplashScreen /> : <App />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <Provider store={store}>
        <PersistGate loading={<SplashScreen />} persistor={persistor}>
            <AppBootstrap />
        </PersistGate>
      </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

registerServiceWorker();
